import { Container, Typography, Box } from "@mui/material";
import LeafLetMap from "../component/LeafLetMap";
import MoreResources from "../component/MoreResources";
import NextBreadcrumbs from "../component/NextBreadcrumbs";
import Page from "../component/Page";
export default function Transportation() {
  return (
    <Page>
      <img src="./background/transportation.jpg" style={{ width: "100%", maxHeight: 250, objectFit: "cover", objectPosition: "center bottom" }}></img>
      <Container sx={{ py: 5 }}>
        <NextBreadcrumbs></NextBreadcrumbs>
        <Box sx={{ py: 1 }}>
          <Typography variant="h3">Transportation</Typography>
          <Typography sx={{ textAlign: "justify", py: 3 }}>
            Kentucky has nearly 80,000 miles of roadway, over 14,000 bridges,
            and over 2,500 miles of railway, critical infrastructure for
            maintaining the state's economic vitality and well-being. Yet
            weather and climate are common impediments impacting transportation;
            severe winds, heavy rainfall, snow and ice, and fog can cause major
            travel problems. Long-term climatic changes, such as increased
            rainfall and higher temperatures, can shorten pavement life and
            undermine bridge supports. More appropriate roadway design, pavement
            materials, and salting operations, carefully determined utilizing
            local climate information, can save millions of dollars annually in
            operations and maintenance costs. More accurate, more local weather
            and climate data are key to safer roads and highways across the
            Commonwealth.
          </Typography>
        </Box>
        <Box sx={{ py: 1 }}>
          <Typography variant="h4">Current Rainfall</Typography>
          <LeafLetMap
            variable={"PRCP"}
          ></LeafLetMap>
        </Box>
        <Box sx={{ py: 1 }}>
          <Typography variant="h4">Current Windspeed</Typography>
          <LeafLetMap
            variable={"WSPD"}
          ></LeafLetMap>
        </Box>
      </Container>
      <MoreResources></MoreResources>
    </Page>
  );
}


